import { css } from '@emotion/css';

import { Colors, LARGE_DEVICE_MQ, Spacing } from 'apps/shared/scripts/styles/constants';

const verticalPadding = Spacing.XL;

export const cardPreviewClassName = css({
  display: 'none',
  position: 'sticky',
  top: `calc(68px + ${verticalPadding}px)`, // navbar height + padding
  [LARGE_DEVICE_MQ]: {
    display: 'block',
  },
});

export const containerClassName = css({
  display: 'flex',
  height: `calc(100vh - (96px + ${verticalPadding}px))`,
  justifyContent: 'center',
});

export const deviceClassName = css({
  border: '12px solid #25303c',
  borderRadius: 36,
  boxShadow:
    '0px 2px 4px 0px rgb(63 63 63 / 10%), 0px -1px 2px rgb(63 63 63 / 8%)',
  maxHeight: 600,
  maxWidth: 311,
  overflow: 'hidden',
  position: 'relative',
  height: '100%',
  width: '100%',
});

export const cardPreviewDesignClassName = css({
  overflowY: 'scroll',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
});

export const cardPreviewCardClassName = css({
  padding: `${Spacing.XL}px 0`,
});

export const cardContainerClassName = css({
  padding: `0 ${Spacing.MD}px`,
});

export const heroClassName = css({
  background: Colors.White,
  borderRadius: 4,
  boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.1)',
  padding: `22px ${Spacing.LG}px`,
});
